var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/speed.1e093e71.png","uri@2x": __webpack_public_path__ + "static/media/speed.a06acc8a.png","uri@3x": __webpack_public_path__ + "static/media/speed.245c2c4e.png",
    width: 30,
    height: 30
});